module.exports = __webpack_public_path__ + "img/20.73a2ea6c.jpg";